import React from 'react';
import ScaffoldContainer from './ScaffoldContainer';

const Scaffold = props => (<ScaffoldContainer {...props} />);

export default Scaffold;
